import { ConfigProvider } from 'antd'
import { ComponentProps } from 'react'

export const theme: ComponentProps<typeof ConfigProvider>['theme'] = {
  components: {
    Segmented: {
      itemActiveBg: 'none',
      trackBg: '#E9ECF0',
      itemSelectedColor: '#722AFF',
      itemColor: '#3D3D3D',
      trackPadding: 2,
      itemHoverBg: 'E9ECF0',
      itemHoverColor: '#722AFF',
    },
    Tabs: {
      itemSelectedColor: '#722AFF',
      itemColor: '#3D3D3D',
      itemHoverColor: '#722AFF',
      inkBarColor: '#722AFF',
    },
  },
}
